import { defineComponent as _defineComponent } from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { ChevronDownIcon, DocumentDownloadIcon } from '@heroicons/vue/solid';
import { ExportFormat } from '@/utils/spreadsheet';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiExportMenu',
  props: {
    compact: {
        type: Boolean,
        default: false,
    },
    label: {
        type: String,
        default: 'Download',
    },
},
  emits: ["select"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const selectFormat = (format: ExportFormat) => {
    emit('select', format);
};

const __returned__ = { emit, selectFormat, get Menu() { return Menu }, get MenuButton() { return MenuButton }, get MenuItem() { return MenuItem }, get MenuItems() { return MenuItems }, get ChevronDownIcon() { return ChevronDownIcon }, get DocumentDownloadIcon() { return DocumentDownloadIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})